import { ApiError, useApiClient } from "@myplant-io/utils/api";
import { useMutation, useQueryClient } from "react-query";
import { ModeStoreEntry } from "../types";

export function useModeStoreEntryDelete() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<ModeStoreEntry, ApiError, { mode_id: string }>(
    ({ mode_id }) => {
      return client.fetch(`/api/mode-store/${mode_id}`, {
        method: "DELETE",
      });
    },
    {
      async onSettled() {
        queryClient.invalidateQueries("mode-store");
        queryClient.invalidateQueries("modes");
      },
    }
  );
}
